import React, { memo } from 'react';
import ListItem from '../ListItem';
import Loader from 'react-loader-spinner';
import { scrolly } from '../../../../../../helpers/commons';
import styles from './scrolly.module.scss';

const ListItems = ({ children, className, listItems, fetchingMoreItems, totalItems, onScrollBottomAction = () => { } }) => {
    

    const getMoreItems = () => {
        const itemsLength = Array.isArray(listItems) ? listItems.length : React.Children.count(listItems);
        
        if (typeof fetchingMoreItems !== "undefined" && !fetchingMoreItems && itemsLength < totalItems) {
            onScrollBottomAction();
        } 
    }

    return (
        <div 
            className={className} 
            style={{ height: '100%', overflow: 'auto' }}
            onScroll={(event) => {
                scrolly(getMoreItems, event);
            }}
        >
            {children}
            {
                fetchingMoreItems &&
                <ListItem className={styles.loader}>
                    <Loader type="ThreeDots" />
                </ListItem>
            }
        </div>
    );
}




export default memo(ListItems);